import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { Box, Typography, darken, lighten, useTheme } from "@mui/material";
import Image from "next/image";
import React from "react";
import { MarqueeText } from "../layouts/MarqueeText/MarqueeText";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";

export function EventCardWarningMessage(props: { description: string }) {
  const theme = useTheme();
  return (
    <Box
      bgcolor={lighten(theme.palette.warning.main, 0.95)}
      px={0.5}
      py={0.5}
      borderRadius={"2px"}
    >
      <Typography
        variant="body2"
        lineHeight={1.2}
        fontSize={"0.8rem"}
        color={darken(theme.palette.warning.main, 0.6)}
      >
        {props.description}
      </Typography>
    </Box>
  );
}

export function EventCardNoInventoryMessage() {
  const teamConfig = useTeamConfig();
  const message = teamConfig?.uiConfigs?.eventCardSettings?.noInventoryMessage;

  if (!message) return null;

  return (
    <Box>
      <Typography
        variant="body1"
        color="text.primary"
        fontSize={"0.9rem"}
        fontWeight={"500"}
      >
        {message}
      </Typography>
    </Box>
  );
}

export const EventLogo = (props: {
  src: string;
  width?: number;
  height?: number;
}) => {
  return (
    <Image
      src={props.src}
      alt={"StadiumBackground team logo"}
      width={props?.width || 48}
      height={props?.height || 48}
      style={{ objectFit: "contain" }}
    />
  );
};

export function EventCardTag(props: {
  label: string;
  color: string;
  isMarqueeDisabled: boolean;
  width?: string;
  customMarqueeMinLength?: number;
}) {
  const theme = useTheme();

  return (
    <Box
      borderRadius={2}
      width={props?.width || "135px"}
      height={"24px"}
      bgcolor={props?.color}
      px={1}
    >
      <MarqueeText
        text={props?.label}
        minLength={props?.customMarqueeMinLength || 16}
        style={{
          fontSize: "12px",
          fontWeight: 500,
          color: theme.palette.common.white,
        }}
      />
    </Box>
  );
}
